import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../layout'
import blank from '../layout/blank'
import setting from './modules/setting'
import content from './modules/content'
import statistics from './modules/statistics'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('../../common/view/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('../view/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('../view/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('../../common/view/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('../../common/view/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: '首页',
      icon: 'dashboard',
      affix: true,
      key: 'dashboard'
    },
    name: 'Dashboard',
    children: [
      {
        path: '/dashboard',
        component: () => import('../view/dashboard/index'),
        name: 'Dashboard',
        meta: {
          title: '首页',
          icon: 'fe-home',
          affix: true
        }
      }
    ]
  },
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/content',
    component: Layout,
    meta: {
        title: '内容管理',
        icon: 'fe-settings',
        roles: [
          'content-teacher-view',
          'content-course-auth-view',
          'content-course-manage-view',
          'content-course-param-view',
        ]
      },
    children: content
  },
  {
    path: '/statistics',
    component: Layout,
    meta: {
        title: '数据统计',
        icon: 'fe-settings',
        roles: [
          'statistics-course_log-view',
          'statistics-course_authorize-view',
          'statistics-course-view',
        ]
      },
    children: statistics
  },
  {
    path: '/setting',
    component: Layout,
    meta: {
        title: '系统设置',
        icon: 'fe-settings',
        roles: [
          'setting-admins-list-view',
          'setting-admins-roles-view',
          'setting-common_param-view',
          'setting-config-view',
          'setting-login-view'
        ]
      },
    children: setting
  },
  {
    path: '/error',
    component: Layout,
    hidden: true,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'Error Pages',
      icon: '404'
    },
    children: [
      {
        path: '401',
        component: () => import('../../common/view/error-page/401'),
        name: 'Page401',
        meta: {title: '401', noCache: true}
      },
      {
        path: '404',
        component: () => import('../../common/view/error-page/404'),
        name: 'Page404',
        meta: {title: '404', noCache: true}
      }
    ]
  },
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true}
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
